import { parse } from 'query-string'

import { QueryParamDefaults } from 'embed/constants'
import { isDev } from 'embed/constants/config'
import { ClientTags, ConfigServiceDataKeys, QueryParamKeys, QueryParamParsers } from '@evenfinancial/even-ts-static'

export interface RawParams {
  [key: string]: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Params = { [K in QueryParamKeys]?: any }

export const TAG_PREFIX = 'tag.'

const excludeFromQP: string[] = [ConfigServiceDataKeys.integrationStatus]

/**
 * @deprecated use embed/utils/query-params
 */
export class QueryParams {
  public getAllRaw(queryString?: string): RawParams {
    return parse(queryString ?? window?.location?.search ?? '')
  }

  public get = (key: QueryParamKeys, queryString?: string) => this.getAll(queryString)[key]

  public getAll = (queryString?: string): Params => {
    const params = { ...QueryParamDefaults }
    Object.entries(this.getAllRaw(queryString)).forEach(([key, value]) => {
      const parser = QueryParamParsers[key] ? QueryParamParsers[key] : undefined
      params[key] = parser !== undefined ? parser(value) : value
    })

    return Object.keys(params).reduce((acc, key) => {
      const excludeKeyFromQP = !isDev && excludeFromQP.includes(key)
      if (params[key] !== null && params[key] !== undefined && !excludeKeyFromQP) acc[key] = params[key]
      return acc
    }, {})
  }

  public getClientTags = (config: ClientTags): ClientTags => {
    // Take all config params or query params if config is empty
    // and filter to only the ones that match actual tag params
    // (formatted like e.g. tag.source)
    // TODO: Only check for config params once we move credit.com widget to use ConfigProvider
    const params = Object.keys(config).length > 0 ? config : this.getAll()
    let clientTags = Object.keys(params).reduce((acc, key) => {
      if (key.startsWith(TAG_PREFIX)) {
        acc[key] = params[key]
      }
      return acc
    }, {}) as ClientTags

    // Remove the namespace from the query param key (tag.source => source)
    clientTags = Object.fromEntries(
      Object.entries(clientTags).map(([key, value]) => [key.substring(TAG_PREFIX.length, key.length), value]),
    )

    // Set the values to arrays
    clientTags = Object.fromEntries(
      Object.entries(clientTags).map(([key, value]) => [key, Array.isArray(value) ? value : [value]]),
    )
    // remove tags with bad values
    return Object.keys(clientTags).reduce((acc, key) => {
      if (clientTags[key][0] !== null && clientTags[key][0] !== undefined) acc[key] = clientTags[key]
      return acc
    }, {})
  }
}

const instance = new QueryParams()

export { instance as default }
